import React from "react";
import PropTypes from "prop-types";

import { useDateFormater } from "../../Hooks/useDateFormater";
import { useUTCLocalConvertor } from "../../Hooks/UTCLocalConvertor";
import { dateFormatEnum } from "../../assets/Js/dateFormatEnum";

export const AssignedTrack = ({
  id,
  name,
  status,
  trialDays,
  price,
  type,
  loggedInUserRole,
  joinedOn,
  handleDeleteRequest,
}) => {
  const dateFormater = useDateFormater();
  const UTCLocal = useUTCLocalConvertor();

  const localHandleDeleteRequest = () => {
    handleDeleteRequest(id);
  };

  return (
    <tr>
      <td>{name}</td>

      <td>
        {status ? (
          <span className="badge-success p-1">Active</span>
        ) : (
          <span className="badge-warning p-1">In Active</span>
        )}
      </td>

      {typeof trialDays === "number" && <td>{trialDays}</td>}
      <td>{price}</td>
      <td>{type}</td>
      {joinedOn && (
        <td>
          {dateFormater(
            UTCLocal({ type: dateFormatEnum.local, date: joinedOn })
          )}
        </td>
      )}
      {handleDeleteRequest && typeof handleDeleteRequest === "function" && (
        <td className="pointerCursor" onClick={localHandleDeleteRequest}>
          Remove
        </td>
      )}
    </tr>
  );
};

AssignedTrack.propTypes = {
  id: PropTypes.number,
  name: PropTypes.string,
  price: PropTypes.number,
  trialDays: PropTypes.number,
  type: PropTypes.string,
  joinedOn: PropTypes.string,
  handleDeleteRequest: PropTypes.func,
  loggedInUserRole: PropTypes.string,
  desiredRole: PropTypes.string,
};
